export default __webpack_public_path__ + "static/media/4.5ac88b8e.jpg";